import React from 'react'
import Header from '@components/Header/Header'
import AutosaveIndicator from './AutosaveIndicator'
import { useRouter } from 'next/router'
import { useTranslation } from '@i18n'

const HeaderContainer = () => {
  const router = useRouter()
  const context = router.query.mode || 'edit'
  const { t } = useTranslation('editor')

  return (
    <Header location={t('header.title', { context })} hideSearch>
      <AutosaveIndicator />
    </Header>
  )
}

export default React.memo(HeaderContainer)
